import { render, staticRenderFns } from "./AdditionalPurchase.vue?vue&type=template&id=358e3974&scoped=true&"
import script from "./AdditionalPurchase.vue?vue&type=script&lang=js&"
export * from "./AdditionalPurchase.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalPurchase.vue?vue&type=style&index=0&id=358e3974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358e3974",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VSelect})
